import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobComment.Save.IRequest;
type Response = Api.Core.ClaimJobComment.Save.IResponse;
type Headers = Api.Core.ClaimJobComment.Save.IHeaders;
const url = '/api/Claims/ClaimJobComment';
export default async function claimJobCommentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
